import {
  Box,
  Button,
  MenuItem,
  TextField,
  Typography
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { color } from "framer-motion";
import { useEffect, useState } from "react";

const MONTHS = [
  "JANUARY", "FEBRUARY", "MARCH", "APRIL",
  "MAY", "JUNE", "JULY", "AUGUST",
  "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
];

const HOLIDAY_TYPES = ["PUBLIC", "WEEKLY"];

const getDateCount = (from, to) => {
  if (!from || !to) return 0;

  const start = new Date(from);
  const end = new Date(to);
  return Math.floor((start - end) / (1000 * 60 * 60 * 24)) + 1;

  // console.log(Math.floor((start - end) / (1000 * 60 * 60 * 24)) + 1);
  // return Math.floor((end - start) / (1000 * 60 * 60 * 24) + 1);
};




export default function HolidayForm({
  mode = "add",            // add | edit | view
  initialData = null,      // backend holiday object
  onSubmit,
}) {
  const isView = mode === "view";
  const isUp = mode === "update";

  const [form, setForm] = useState({
    name: "",
    description: "",
    holidayDate: null,
    fromDate: null,
    numdays: 0,
    month: "",
    year: "",
    status: "Active",
    holidayType: "PUBLIC",
  });
  const [error, setError] = useState("");

  useEffect(() => {
    if (initialData) {
      setForm({
        id: initialData.id,
        name: initialData.name ?? "",
        description: initialData.description ?? "",
        holidayDate: initialData.toDate
          ? dayjs(initialData.toDate)
          : null,
        month: initialData.month ?? "",
        fromDate: initialData.toDate
          ? dayjs(initialData.toDate)
          : null,
        year: initialData.year ?? "",
        status: initialData.status ?? "",
        holidayType: initialData.holidayType ?? "",
      });
    }
  }, [initialData]);

  const handleChange = (field) => (e) => {
    setForm({ ...form, [field]: e.target.value });
  };

  const handleSubmit = () => {
    if (!form.name || !form.holidayDate || !form.holidayType || !form.fromDate) {
      setError('name, toDate, holidayType & fromDate is required fields');
      return;
    }

    const payload = {
      id: form.id,
      name: form.name,
      description: form.description ?? "",
      toDate: form.holidayDate.format("YYYY-MM-DD"),
      fromDate: form.fromDate.format("YYYY-MM-DD"),
      numdays: form.numdays,
      status: form.status,
      holidayType: form.holidayType,
    };

    onSubmit(payload);
  };

  return (
    <Box sx={{ maxWidth: 600 }}>

      <Box display="grid" gap={2}>
        <TextField
          required
          label="Name"
          value={form.name}
          onChange={handleChange("name")}
          disabled={isView}
        />

        <TextField
          label="Description"
          value={form.description}
          onChange={handleChange("description")}
          disabled={isView}
          multiline
          rows={2}
        />

        <DatePicker
          required
          label="To Date"
          value={form.holidayDate}
          minDate={dayjs()}
          onChange={(value) => {
            setForm(prev => ({
              ...prev,
              holidayDate: value,
              numdays: prev.fromDate && value
                ? getDateCount(prev.fromDate, value)
                : 0
            }));
          }}
          disabled={isView}
        />

        <DatePicker
          required
          label="From Date"
          value={form.fromDate}
          minDate={form.holidayDate && form.holidayDate.isAfter(dayjs())
            ? form.holidayDate
            : dayjs()}
          onChange={(value) => {
            setForm(prev => ({
              ...prev,
              fromDate: value,
              numdays: value && prev.holidayDate
                ? getDateCount(value, prev.holidayDate)
                : 0
            }));
          }}
          disabled={isView}
        />

        {isView && (<>
          {/* <TextField
            select
            label="Month"
            value={form.month}
            onChange={handleChange("month")}
            disabled={isView}
          >
            {MONTHS.map((m) => (
              <MenuItem key={m} value={m}>
                {m}
              </MenuItem>
            ))}
          </TextField> */}

          <TextField
            label="month"
            value={form.month}
            disabled={isView}
          />

          <TextField
            label="Year"
            type="number"
            value={form.year}
            // onChange={handleChange("year")}
            disabled={isView}
          />
        </>)}

        <TextField
          label="Status"
          value={form.status}
          onChange={handleChange("status")}
          disabled={isView}
        />

        <TextField
          required
          select
          label="Holiday Type"
          value={form.holidayType}
          onChange={handleChange("holidayType")}
          disabled={isView}
        >
          {HOLIDAY_TYPES.map((t) => (
            <MenuItem key={t} value={t}>
              {t}
            </MenuItem>
          ))}
        </TextField>
        <Typography sx={{ color: 'red', fontSize: 9, fontWeight: 500 }}>{error}</Typography>
        {!isView && (
          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{ bgcolor: '#1b1914', py: 0.8, borderRadius: 5 }}
          >
            {mode === "add" ? "Save" : "Update"}
          </Button>
        )}
      </Box>
    </Box>
  );
}
